import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { IPayslips } from 'API/Paychecks/paychecks';
import { NextPrevBtn, NextPrevBtnDisabled } from 'Images';
import { format } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { he } from 'date-fns/locale';
import { useDictionary } from 'Hooks';

interface IPaychecksSwitcher {
  currentIndex: number;
  setCurrentIndex: (value: number) => void;
  currentPaycheck: IPayslips | null;
  paychecks: IPayslips[];
}

export const PaychecksSwitcher = ({
  currentIndex,
  setCurrentIndex,
  currentPaycheck,
  paychecks,
}: IPaychecksSwitcher) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userPaychecks;

  const MAX_ITEMS = paychecks.length;

  const handleNext = () => {
    if (currentIndex < MAX_ITEMS) setCurrentIndex(currentIndex + 1);
  };

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  return (
    <Stack
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
    >
      <Button
        onClick={handleNext}
        disabled={currentIndex >= MAX_ITEMS - 1}
        sx={{
          transform:
            currentIndex === 0 || currentIndex >= MAX_ITEMS - 1
              ? 'rotate(180deg)'
              : undefined,
          width: '32px',
          height: '32px',
          minWidth: '32px',
        }}
      >
        <Avatar
          src={
            currentIndex >= MAX_ITEMS - 1 ? NextPrevBtnDisabled : NextPrevBtn
          }
          alt=''
          sx={{
            m: 0,
            width: '32px',
            height: '32px',
            transform: currentIndex !== 0 ? undefined : 'rotate(180deg)',
          }}
        />
        <Box className='sr-only'>{dictionary.nextPaycheck}</Box>
      </Button>
      {currentPaycheck && (
        <Typography variant='body2' sx={{ width: '100%', textAlign: 'center' }}>
          {format(
            new Date(
              parseInt(currentPaycheck.year),
              parseInt(currentPaycheck.month) - 1
            ),
            'MMMM',
            { locale: he }
          )}{' '}
          {currentPaycheck.year}
        </Typography>
      )}
      <Button
        onClick={handlePrev}
        disabled={currentIndex === 0}
        sx={{
          transform: currentIndex === 0 ? undefined : 'rotate(180deg)',
          minWidth: '32px',
          height: '32px',
          p: 0,
        }}
      >
        <Avatar
          src={currentIndex === 0 ? NextPrevBtnDisabled : NextPrevBtn}
          alt=''
          sx={{ m: 0, width: '32px', height: '32px' }}
        />
        <Box className='sr-only'>{dictionary.prevPaycheck}</Box>
      </Button>
    </Stack>
  );
};
